module.exports = __webpack_public_path__ + "static/img/design-4.d0242055.png";